import React from 'react';
import ReactDOM from 'react-dom';
import { TextField, ThemeProvider } from '@mui/material';
import { createDebouncedUpdate, updateCellProperty } from '../utils/InspectorUtils';

export function renderInputField(field, cell, theme) {
  const container = document.createElement('div');
  const InputField = () => {
    const [value, setValue] = React.useState(cell.get(field.path) || field.defaultValue || '');
    const [debouncedValue] = React.useState(() =>
      createDebouncedUpdate((newValue, updateGraphImmediately) => {
        updateCellProperty(cell, field, field.path, newValue, { silent: false });
        // Force a change event to ensure the graph is updated
        cell.trigger('change:attrs change:customAttributes', cell, {
          ...cell.attributes,
          [field.path]: newValue,
        });
      })
    );

    const handleChange = (e, updateGraphImmediately) => {
      const newValue = e.target.value;
      setValue(newValue);
      debouncedValue(newValue, updateGraphImmediately);
    };

    React.useEffect(() => () => debouncedValue.cancel(), [debouncedValue]);

    return (
      <ThemeProvider theme={theme}>
        <TextField
          fullWidth
          size="small"
          label={field.label}
          variant="outlined"
          value={value}
          onBlur={field.readOnly ? undefined : (event) => handleChange(event, true)}
          onChange={field.readOnly ? undefined : (event) => handleChange(event, false)}
          required={field.required}
          error={field.required && !value}
          helperText={field.required && !value ? 'Ce champ est requis' : ''}
          disabled={field.readOnly}
          inputProps={{
            'data-cy': field.attributes?.['data-cy'],
            onCompositionStart: (e) => e.stopPropagation(),
            onCompositionEnd: (e) => e.stopPropagation(),
          }}
        />
      </ThemeProvider>
    );
  };
  ReactDOM.render(<InputField />, container);
  return container;
}
